import React, { useCallback, useRef } from "react";
import { toast } from "react-toastify";
import api from "../Api/api";

export default function useOnClientDelete(
  id: string,
  name: string,
  refresh: () => Promise<void>
) {
  const toastId = useRef<any>(null);
  return useCallback(
    async (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (toast.isActive(toastId.current)) return;
      toastId.current = toast(
        `Are you sure you want to delete ${name}? Click here to delete.`,
        {
          type: "error",
          autoClose: 15000,
          position: "top-center",
          onClick: async () => {
            await api.deleteClient(id);
            toast("Client deleted!", { type: "success" });
            refresh();
          },
        }
      );
    },
    [id, name, refresh]
  );
}
